<template>
    <el-form
        ref="forgotPasswordForm"
        :model="form"
        :rules="rules"
        @keyup.enter.native="onSubmit"
    >
        <p class="orangetext" v-if="currentAward">
            Fill in the e-mail linked with your account below to start the password restoration process.
        </p>
        <el-form-item
            prop="email"
            :error="$t(formErrors.get('email'))"
            class="form-group"
        >
            <el-input
                v-model="form.email"
                name="email"
                :placeholder="$t('auth.login.email_label')+' *'"
                type="text"
            />
        </el-form-item>
        <el-row>
            <el-col :xs="24" class="text-right">
                <el-button
                    :loading="loading"
                    class="loginButton"
                    @click.native="onSubmit"
                >
                    Submit
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import {Errors} from '../../../includes/Errors'

export default {
    name: 'ForgotPasswordForm',
    props: {
        errors: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                email: ''
            },
            rules: {
                email: [{
                    required: true,
                    message: this.$t('global.form.rules.required', {'fieldName': this.$t('auth.login.email_label')}),
                    trigger: 'blur'
                }]
            },
            formErrors: new Errors()
        }
    },
    watch: {
        errors: function () {
            this.formErrors.record(this.errors)
        }
    },
    methods: {
        onSubmit(e) {
            this.$refs['forgotPasswordForm'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', {
                        ...this.form
                    })
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
.el-form-item__label {
    padding: 0 !important;
}

.sign-up-form {

    .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
            padding: 0 !important;
        }
    }
}

</style>
